import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  ContainerList,
  ContentImageList,
  ImageList,
  LiItem,
  TitleItemList,
  UL,
} from "../style/style";
import { NB_ContextMenuProps } from "../type/contextMenu.type";

export const ContextMenuView = (props: Partial<NB_ContextMenuProps>) => {
  return (
    <div
      style={{
        display: "flex",
        // display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      <MoreVertIcon sx={{ cursor: "pointer" }} onClick={props.hideListFn} />
      <ContainerList isHidden={props.isHidden}>
        <UL>
          {props.listItem?.map((item) => (
            <LiItem
              key={item.id}
              onClick={() => {
                if (props.onClickItemList && props.setIsHidden) {
                  props.onClickItemList(item);
                  props.setIsHidden(true);
                }
              }}
            >
              <ContentImageList>
                <ImageList src={item.iconImg} alt={"reprocess"} />
              </ContentImageList>
              <TitleItemList colorText={item.colorText}>
                {item.name}
              </TitleItemList>
            </LiItem>
          ))}
        </UL>
      </ContainerList>
    </div>
  );
};
